import type { HTMLAttributes } from "react";

import "./card.css";
import { cardClass, type CardPadding, type CardVariant } from "./card-class";

export type { CardPadding, CardVariant } from "./card-class";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: CardVariant;
  padding?: CardPadding;
}

/**
 * Surface container. Token-driven; a neutral surface (no tone). Presentational — compose
 * interactive controls (Button/IconButton/links) inside rather than making the card itself a
 * control, to avoid nested-interactive a11y problems.
 */
export function Card({ variant = "solid", padding = "md", className, ...rest }: CardProps) {
  return <div className={cardClass(variant, padding, className)} {...rest} />;
}
